// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2-uiU","title":"BackImages_title__2EtoM","images":"BackImages_images__25rm2"};